import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 100vh;
`;

export const ContainerOut = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    align-items: center;
    padding: 2rem 0;
    width: 100%;
    `;

export const Content = styled.div`
    display: flex;
    flex-direction: row;
    width: 80%;
    max-width: 1300px;
    min-height: 60vh;
    justify-content: space-between;
    background-color: ${({ theme }) => theme.menuBackground};
    box-shadow: 5px 5px 15px 5px rgba(0,0,0,0.25);
`;


export const Column = styled.div`
    width: 50%;
    margin-left: 0%;
    box-shadow: 0px 0px 0px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgb(255, 255, 255);

`;
export const Titulo = styled.div`
    display: flex;
    flex-direction: row;
    -webkit-box-align: center;
    align-items: center;
    padding-left: 3%;
    width: 100%;
    height: 25%;

    h1{
    font-size: 5rem;
    padding: 0px;
    margin: 0px auto 0px 0px;
    font-weight: bolder;
    letter-spacing: 0.2rem;
}
`;




export const Positions = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 25%;
    padding: 0.5rem;
    padding-left:20px ;

`;

export const Square = styled.div`
    width: 18%;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.green};
    

    h1{
    font-size: 2.5rem;
    font-family: "roboto";
    color: rgb(255, 255, 255);
}
    
`;

export const SquareImg = styled.img`
    width: 20%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    img {
        object-fit: cover;
        width: 100%;
    }
`;

export const Name = styled.div`
    width: 60%;
    padding: 0px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

`;

export const Points = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;

p{
    font-weight: bold;
    color: ${({ theme }) => theme.gray};
    letter-spacing: 0.1rem;
    font-size: 1.05rem;
    margin-top: auto;
    margin-bottom: 0px;
}
`;

export const Positions2 = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 25%;
    padding: 0.5rem;
    padding-left:20px ;
`;

export const Positions3 = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 25%;
    padding: 0.5rem;
    padding-left:20px ;


`;

export const Positions4 = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 25%;
    padding: 0.5rem;
    padding-left:20px ;


`;

export const PositionsSec = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 25%;
    padding: 0.5rem;
    padding-left:20px ;
    padding-top:36px ;

`;